import { useMutation } from 'react-query';
import { network } from 'services/network';
import qs from 'qs';

const mutationFn = ({ customerId, name, projectId }: QueryParams) => {
    const querystring = qs.stringify({ customerId, name, projectId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/createTag${querystring}`;
    return network.post(url).then((response) => {
        return response.data;
    });
};

export const useMutationCreateTag = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    customerId: number;
    name: string;
    projectId: number;
}
